import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import Select from 'react-select';

class StaffsMatterTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      matter_id: null,
      lista_materias: [],
      dados: [],
    };

    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarMateria = this.adicionarMateria.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.materias) && Array.isArray(newProps.lista_materias)) {
      this.setState({dados: newProps.materias, lista_materias: newProps.lista_materias});
    }
  }

  adicionarMateria(event) {
    event.preventDefault();
    var dados_salvar = {
      matter_id: this.state.matter_id,
      staff_id: this.props.staff_id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alunos/materias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_matter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa matéria?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aluno/materia/' + staff_matter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_matter_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_matter_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == staff_matter_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar Matérias</h3>
  <hr/>
      <form onSubmit={this.adicionarMateria}> 
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Matéria:</label>
              <Select
                className="form-field-name"
                name="matter_id"
                value={this.state.matter_id}
                searchable={true}
                placeholder={'Selecionar Matéria'}
                onChange={this.handleSelectChange.bind(this, 'matter_id')}
                options={this.state.lista_materias}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> Adicionar Matéria</button>
            </div>
          </div>
        </div>
      </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há matérias cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="materia_nome" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffsMatterTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsMatterTab.js